'use client';

import styled, { css } from 'styled-components';

export const ItemBase = styled.button<{
  $active?: boolean;
}>`
  position: relative;

  display: flex;
  align-items: center;
  flex-shrink: 0;

  height: 70px;
  padding: 0 16px;
  border: none;

  font-size: 18px;

  color: var(--navbar-color, #282828);
  background: transparent;

  cursor: pointer;
  pointer-events: all;
  text-decoration: none;

  box-sizing: border-box;

  &:focus-visible {
    outline-offset: -8px;
    outline: 2px solid var(--navbar-toggle-background, #700);
  }

  &:hover {
    color: var(--navbar-color, #282828);
    background-color: var(--navbar-toggle-background-hover, #fff0f0);

    &::before {
      content: '';
      position: absolute;

      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background-color: var(--navbar-toggle-background, #700);
    }
  }

  ${({ $active }) =>
    $active &&
    css`
      color: #fff;
      background: var(--navbar-toggle-background, #700) !important;

      &:focus-visible {
        outline-offset: -8px;
        outline: 2px solid var(--navbar-toggle-color, #fff);
      }

      &:hover {
        color: #fff;
      }
    `}

  & > i {
    font-size: 24px;
    line-height: 24px;
  }

  @media (max-width: 768px) {
    height: 56px;
  }
`;

export const Title = styled.span<{ $hideOnMobile: boolean }>`
  margin-left: 8px;
  font-family: 'Storebrand Text', sans-serif;

  ${({ $hideOnMobile }) =>
    $hideOnMobile === true &&
    css`
      @media (max-width: 768px) {
        display: none;
      }
    `}

  @media (max-width: 340px) {
    display: none;
  }
`;

export const Badge = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;
  height: 24px;
  width: 24px;

  color: var(--navbar-toggle-badge-color, #fff0f0);
  background: var(--navbar-toggle-badge-background, #700);

  font-size: 12px;
`;
